import React, { PureComponent } from 'react'

import './person-panel.scss'

type Props = {
  personDisplayName: string
  personFunction: string
  isLast: boolean
}

export class PersonPanelOrgItem extends PureComponent<Props> {
  render() {
    const { personDisplayName, personFunction, isLast } = this.props

    const liClassName = isLast ? 'last' : ''

    return (
      <li className={liClassName}>
        <span className="person-panel__orgchart__dot" />
        <span className="person-panel__orgchart__line" />
        <span className="person-panel__orgchart__name">{personDisplayName}</span>
        <span className="person-panel__orgchart__function">{personFunction}</span>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/person-panel/person-panel-orgperson.component.tsx